import React, { useState, useEffect } from 'react';
import { getCityCoordinates, getAllCities } from '../data/citiesCoordinates';
import {
  VOIVODESHIPS,
  formatVoivodeshipLabel,
  getVoivodeshipForCity,
} from '../data/cityVoivodeships';

const EventForm = ({ onAddEvent, onUpdateEvent, onClose, editingEvent, isSimple = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    address: '',
    city: '',
    voivodeship: '',
    date: '',
    time: '',
    type: '',
    price: '',
    showPrice: true,
    link: '',
    organizer: '',
    phone: '',
    email: '',
    isMultiDay: false,
    endDate: ''
  });

  // Usunięto zmienne stanu związane z geokodowaniem API

  // Wypełnij formularz danymi do edycji
  useEffect(() => {
    if (editingEvent) {
      setFormData({
        name: editingEvent.name || '',
        description: editingEvent.description || '',
        address: editingEvent.address || '',
        city: editingEvent.city || '',
        voivodeship: editingEvent.voivodeship || getVoivodeshipForCity(editingEvent.city || '') || '',
        date: editingEvent.date || '',
        time: editingEvent.time || '',
        type: editingEvent.type || '',
        price: editingEvent.price || '',
        showPrice: editingEvent.showPrice !== undefined ? editingEvent.showPrice : true,
        link: editingEvent.link || '',
        organizer: editingEvent.organizer || '',
        phone: editingEvent.phone || '',
        email: editingEvent.email || '',
        isMultiDay: editingEvent.isMultiDay || false,
        endDate: editingEvent.endDate || ''
      });
    }
  }, [editingEvent]);

  // Użyj bazy danych miast zamiast hardcoded listy
  const polishCities = getAllCities();

  // Lista typów wydarzeń
  const eventTypes = [
    'Koncert', 'Festival', 'Impreza', 'Wystawa', 'Teatr', 'Kino', 
    'Sport', 'Kultura', 'Edukacja', 'Biznes', 'Inne'
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'city') {
      const voivodeshipFromCity = getVoivodeshipForCity(value) || '';
      setFormData(prev => ({
        ...prev,
        city: value,
        voivodeship: voivodeshipFromCity || prev.voivodeship,
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };


  // Pobieranie współrzędnych z bazy danych (bez API)
  const getCoordinates = (city) => {
    const coordinates = getCityCoordinates(city);
    return {
      lat: coordinates[0],
      lng: coordinates[1]
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.date) {
      alert(
        isSimple
          ? 'Proszę wypełnić wymagane pola (nazwa wydarzenia, data)'
          : 'Proszę wypełnić wymagane pola (nazwa wydarzenia, miasto, data)'
      );
      return;
    }

    if (!formData.voivodeship) {
      alert('Proszę wybrać województwo');
      return;
    }

    if (!isSimple && !formData.city) {
      alert('Proszę wybrać miasto');
      return;
    }

    if (formData.isMultiDay && (!formData.date || !formData.endDate)) {
      alert('Proszę wypełnić datę rozpoczęcia i zakończenia dla wydarzenia wielodniowego');
      return;
    }

    // Pobieranie współrzędnych z bazy danych
    const coordinates = getCoordinates(formData.city);

    try {

    const baseEventData = {
      id: editingEvent ? editingEvent.id : Date.now(),
      name: formData.name,
      description: formData.description,
      address: formData.address,
      city: formData.city,
      voivodeship: formData.voivodeship,
      time: formData.time,
      type: formData.type || 'Koncert',
      price: formData.price || 'Bezpłatnie',
      showPrice: formData.showPrice,
      link: formData.link,
      organizer: formData.organizer,
      phone: formData.phone,
      email: formData.email,
      coordinates: [coordinates.lat, coordinates.lng],
      isMultiDay: formData.isMultiDay,
      endDate: formData.endDate,
      createdAt: editingEvent ? editingEvent.createdAt : new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    if (formData.isMultiDay && formData.date && formData.endDate) {
      // Wydarzenie wielodniowe - zapisz jako jedno wydarzenie z zakresem dat
      const eventData = {
        ...baseEventData,
        date: formData.date,
        endDate: formData.endDate,
        isMultiDay: true
      };

      if (editingEvent) {
        await onUpdateEvent(eventData);
      } else {
        await onAddEvent(eventData);
      }
    } else {
      // Pojedyncze wydarzenie
      const eventData = {
        ...baseEventData,
        date: formData.date,
        isMultiDay: false
      };

      if (editingEvent) {
        await onUpdateEvent(eventData);
      } else {
        await onAddEvent(eventData);
      }
    }
    
    onClose();
    } catch (error) {
      console.error('Error submitting event:', error);
      // Błąd jest już obsłużony w App.js, więc nie pokazujemy dodatkowego komunikatu
    }
  };

  return (
    <div className="event-form-overlay">
      <div className="event-form">
        <div className="event-form-header">
          <h2>
            {editingEvent
              ? '✏️ Edytuj event'
              : isSimple
                ? '📨 Zgłoś wydarzenie'
                : '➕ Dodaj nowy event'}
          </h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nazwa wydarzenia *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="date">Data *</label>
              <input
                type="date"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                required
                min="2025-01-01"
                max="2099-12-31"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="time">Godzina</label>
              <input
                type="time"
                id="time"
                name="time"
                value={formData.time}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="address">Adres</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="city">{isSimple ? 'Miejscowość' : 'Miasto *'}</label>
            {isSimple ? (
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
              />
            ) : (
              <select
                id="city"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                required
              >
                <option value="">Wybierz miasto</option>
                {polishCities.map(city => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </select>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="voivodeship">Województwo *</label>
            <select
              id="voivodeship"
              name="voivodeship"
              value={formData.voivodeship}
              onChange={handleInputChange}
              required
            >
              <option value="">Wybierz województwo</option>
              {VOIVODESHIPS.map((voivodeship) => (
                <option key={voivodeship} value={voivodeship}>
                  {formatVoivodeshipLabel(voivodeship)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="link">Link do wydarzenia</label>
            <input
              type="url"
              id="link"
              name="link"
              value={formData.link}
              onChange={handleInputChange}
            />
          </div>

          {/* Pełny formularz tylko dla admin panelu */}
          {!isSimple && (
            <>
              <div className="form-group">
                <label htmlFor="description">Opis wydarzenia</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label htmlFor="type">Typ wydarzenia</label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleInputChange}
                >
                  <option value="">Wybierz typ</option>
                  {eventTypes.map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="price">Cena</label>
                  <input
                    type="text"
                    id="price"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    placeholder="np. 50 zł, Bezpłatnie"
                  />
                </div>
                
                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="showPrice"
                      checked={formData.showPrice}
                      onChange={handleInputChange}
                    />
                    Pokaż cenę na wydarzeniu
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="organizer">Organizator</label>
                <input
                  type="text"
                  id="organizer"
                  name="organizer"
                  value={formData.organizer}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Telefon</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="isMultiDay"
                    checked={formData.isMultiDay}
                    onChange={handleInputChange}
                  />
                  Wydarzenie wielodniowe
                </label>
              </div>

              {formData.isMultiDay && (
                <div className="form-group">
                  <label htmlFor="endDate">Data zakończenia *</label>
                  <input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleInputChange}
                    min={formData.date}
                    max="2099-12-31"
                  />
                </div>
              )}
            </>
          )}

          <div className="form-actions">
            <button type="button" onClick={onClose} className="cancel-btn">
              Anuluj
            </button>
            <button type="submit" className="submit-btn">
              {editingEvent ? 'Zapisz zmiany' : (isSimple ? 'Wyślij zgłoszenie' : 'Dodaj event')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EventForm;
